var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSortDesc = function SvgSortDesc(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23491 14.8322C4.54812 14.519 5.05593 14.519 5.36914 14.8322L8.00114 17.4642L10.6331 14.8322C10.9463 14.519 11.4542 14.519 11.7674 14.8322C12.0806 15.1455 12.0806 15.6533 11.7674 15.9665L8.56826 19.1656C8.25505 19.4788 7.74723 19.4788 7.43402 19.1656L4.23491 15.9665C3.9217 15.6533 3.9217 15.1455 4.23491 14.8322Z",
    fill: "#6D6A73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00114 5C8.44409 5 8.80317 5.35908 8.80317 5.80203V18.5985C8.80317 19.0414 8.44409 19.4005 8.00114 19.4005C7.55819 19.4005 7.19911 19.0414 7.19911 18.5985V5.80203C7.19911 5.35908 7.55819 5 8.00114 5Z",
    fill: "#6D6A73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3982 5.80203C10.3982 5.35908 10.7573 5 11.2003 5H19.198C19.6409 5 20 5.35908 20 5.80203C20 6.24497 19.6409 6.60405 19.198 6.60405H11.2003C10.7573 6.60405 10.3982 6.24497 10.3982 5.80203Z",
    fill: "#6D6A73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3982 9.00114C10.3982 8.55819 10.7573 8.19911 11.2003 8.19911H16.7986C17.2416 8.19911 17.6007 8.55819 17.6007 9.00114C17.6007 9.44409 17.2416 9.80317 16.7986 9.80317H11.2003C10.7573 9.80317 10.3982 9.44409 10.3982 9.00114Z",
    fill: "#6D6A73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3982 12.2003C10.3982 11.7573 10.7573 11.3982 11.2003 11.3982H14.3993C14.8423 11.3982 15.2013 11.7573 15.2013 12.2003C15.2013 12.6432 14.8423 13.0023 14.3993 13.0023H11.2003C10.7573 13.0023 10.3982 12.6432 10.3982 12.2003Z",
    fill: "#6D6A73"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSortDesc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sort-desc.f5dc0965306232cfbdd27940910fdded.svg";